var dlsBrightBlue = {
  "color": "#006fcf !important",
  "fill": "#006fcf !important"
};

export { dlsBrightBlue };
